module.exports = __webpack_public_path__ + "static/media/teacher.6541cdd1.png";